<template>
  <div>
    <PageHeader :gradientType="gradientType" />
    <PageContent>
      <template #filterBar>
        <form @submit.prevent="setFilter">
          <h6 class="heading-small text-muted mb-4">Search</h6>
          <div class="row">
            <div class="col">
              <a-input placeholder="Search by" v-model="table.filters.name">
                <a-select
                  slot="addonAfter"
                  default-value="name"
                  style="width: 80px"
                >
                  <a-select-option value="name">
                    Name
                  </a-select-option>
                </a-select>
              </a-input>
            </div>
          </div>
          <hr />
          <h6 class="heading-small text-muted mb-4">Filter by Status</h6>
          <div class="row">
            <div class="col">
              <a-radio-group
                v-model="table.filters.status_code"
                :default-value="null"
                @change="setFilter"
              >
                <a-radio :style="radio.style" :value="null">
                  All
                </a-radio>
                <a-radio :style="radio.style" value="A">
                  Active
                </a-radio>
                <a-radio :style="radio.style" value="I">
                  Inactive
                </a-radio>
              </a-radio-group>
            </div>
          </div>
        </form>
      </template>

      <template #pageTable>
        <PageTable
          :tableTitle="table.title"
          :apiUrl="table.apiUrl"
          :tableFields="table.fields"
          :appendedParams="table.filters"
        >
          <template #headerButtons>
            <base-button
              id="new"
              v-if="selectedActions.includes('Add')"
              class="float-right ml-1"
              type="primary"
              size="sm"
              @click="openDrawer()"
              >+ Add Card Type</base-button
            >
          </template>

          <template #formDrawer>
            <a-drawer
              :width="drawer.width"
              :placement="drawer.placement"
              :visible="drawer.visible"
              @close="closeDrawer"
            >
              <CardTypeForm
                :viewMode="viewMode"
                :cardTypeData="cardTypeData"
                @closeDrawer="closeDrawer"
              />
            </a-drawer>
          </template>

          <template #tableButtons="{tableProps}">
            <div class="d-flex justify-content-around">
              <button
              id="view"
              v-if="selectedActions.includes('View')"
              class="btn btn-success btn-sm w-100"
              @click.prevent="openDrawer(tableProps.rowData)"
            >
              View
              </button>
              <button
                id="edit"
                v-if="selectedActions.includes('Edit')"
                class="btn btn-warning btn-sm w-100"
                @click.prevent="openDrawer(tableProps.rowData)"
              >
                Edit
              </button>
              <a-popconfirm
                v-if="
                  tableProps.rowData.card_number_series ==
                    tableProps.rowData.last_card_number &&
                    selectedActions.includes('Delete')
                "
                title="You are about to delete this record?"
                @confirm="deleteRow(tableProps.rowData)"
                okText="Delete"
                cancelText="Cancel"
              >
                <a class="btn btn-danger btn-sm text-white  w-100">Delete</a>
              </a-popconfirm>
            </div>
          </template>
        </PageTable>
      </template>
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '../../components/Page/Header.vue';
import PageContent from '../../components/Page/Content.vue';
import PageTable from '../../components/Page/Table.vue';
import CardTypeForm from './CardTypeForm.vue';
import HTTPRequest from '../../controllers/httpRequest';
import { mapGetters } from 'vuex';

export default {
  components: {
    PageHeader,
    PageContent,
    PageTable,
    CardTypeForm
  },
  data() {
    return {
      gradientType: 'gradient-teal',
      // selectedActions: [],
      cardTypeData: null,
      drawer: {
        visible: false,
        width: 480,
        placement: 'right'
      },
      viewMode: false,
      table: {
        title: 'Card Types',
        apiUrl: '/api/v1/clp_card_types',
        fields: [
          'actions',
          // 'id',
          'name',
          { name: 'card_number_series', title: 'Card Number Series' },
          { name: 'last_card_number', title: 'Last Card Number Generated' },
          'status'
        ],
        filters: {
          status_code: null,
          name: null
        }
      },

      radio: {
        style: {
          display: 'block',
          height: '35px',
          lineHeight: '30px'
        }
      }
    };
  },
  computed: {
    ...mapGetters({
      selectedActions: 'getModuleSelectedActions'
    })
  },
  methods: {
    openDrawer(rowData = null) {
      this.viewMode = event.target.id == 'view' ? true : false;
      this.cardTypeData = rowData;
      this.drawer.visible = true;
    },

    closeDrawer() {
      this.drawer.visible = false;
      this.cardTypeData = null;
    },

    setFilter() {
      this.$root.$emit('refreshTable');
    },

    async deleteRow(rowData) {
      const cardTypeId = rowData.id;
      const requestBody = {
        card_type: { membership_program_id: rowData.membership_program_id }
      };
      const response = await HTTPRequest.deleteRequest(
        `/api/v1/clp_card_types/${cardTypeId}`,
        requestBody
      );

      if (response.message == 'Success') {
        this.$notification.success({
          message: 'Success'
        });
        this.$root.$emit('refreshTable');
      } else {
        if (response.error != undefined) {
          this.$notification.error({
            message: response.error
          });
        } else {
          this.$notification.error({
            message: 'Something went wrong. Please try again.'
          });
        }
      }
    }
  },

  created() {
    this.$store.dispatch('setCurrentModule', 'CardType');
  },

  mounted() {
    this.selectedActions = this.$store.getters.getModuleSelectedActions;
  }
};
</script>

<style scoped></style>
